import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

export interface PaginatorData {
  page: number;
  limit?: number;
  pageLimit?: number;
}

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() data: PaginatorData;
  @Input() disabled: boolean;
  @Output() paginatorChanges: EventEmitter<PaginatorData> = new EventEmitter<PaginatorData>();

  limitControl: FormControl;
  constructor() {
    this.limitControl = new FormControl(10, [Validators.required]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data?.currentValue?.limit)
      this.limitControl.setValue(changes.data?.currentValue?.limit, { emitEvent: false });

    if (changes.disabled?.currentValue) this.limitControl.disable({ emitEvent: false });
    else this.limitControl.enable({ emitEvent: false });
  }

  ngOnInit(): void {
    this.limitControl.setValue(this.data.limit);
    this.limitControl.valueChanges.subscribe((newLimit) => {
      this.emitPaginatorEvent(this.data.page, newLimit);
    });
  }

  emitPaginatorEvent(newPage: number, newLimit: number) {
    if (newPage < 1) return;
    this.paginatorChanges.emit({
      page: newPage,
      limit: newLimit,
    });
  }
}
